module.exports = __webpack_public_path__ + "static/favicon-0931cf9803e05199e6f20440d3334b0d.png";